import { render, staticRenderFns } from "./SearchResultsComponent.vue?vue&type=template&id=cb38ff9e&"
import script from "./SearchResultsComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports